module.exports = __webpack_public_path__ + "static/media/IconTemplates_-45.af1a0ad5.svg";